// extracted by mini-css-extract-plugin
export default {"root":"WeekCalendar_root__j-Bxh","todayTd":"WeekCalendar_todayTd__7e+KS","todayTh":"WeekCalendar_todayTh__9nCMd","emptyCell":"WeekCalendar_emptyCell__aMPn9"};